import React, { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import StoregmIcon from '../assets/icons/store.png'
import SidebarArrow from '../assets/icons/sidebar_arrow.png'
import SysAdminIcon from '../assets/icons/user.png'
import DevOppIcon from '../assets/icons/iteration.png'
import Dashboard from '../assets/icons/dashboard.png'
// import { Tooltip } from "primereact/tooltip";

const DashboardMenu = {
    label: "Dashboard",
    icon: Dashboard,
    keywords: "dashboard",
    marginDimension: "0.5em",
    highlightClass: "",
    module: "dashboard",
    configaccess: "showBroker",
    path: "/ui/dashboard",
};

const IntegrationMenu = {

    label: "Integration",
    icon: StoregmIcon,
    keywords: "consumer management,producer management",
    marginDimension: "0.5em",
    childMenu: "integrationSubMenu",
    highlightClass: "",
    module: "Integration",
    configaccess: "showBroker",
    child: [
        {
            label: "Store",
            path: "/ui/system-store",
            group: "Integration",
            module: "Store",
            menuIcon: 'pi pi-shopping-bag',
        },
        {
            label: "Configuration",
            path: "/ui/prop-confg",
            group: "Integration",
            module: "propconfig",
            menuIcon: 'pi pi-cog',

        },
        {
            label: "Integration File ",
            path: "/ui/integration-file",
            group: "Integration",
            module: "File",
            menuIcon: 'pi pi-folder-open',
        },
        {
            label: "Integration File Log",
            path: "/ui/integration-file-log",
            group: "Integration",
            module: "FileLog",
            menuIcon: 'pi pi-file-o',
        },
        {
            label: "Integration Outbound File",
            path: "/ui/int-outbound-file",
            group: "Integration",
            module: "outBoundFile",
            menuIcon: 'pi pi-file-o',
        },
        {
            label: "Integration Schedule Queue",
            path: "/ui/file-upload-queue",
            group: "Integration",
            module: "UploadQueue",
            menuIcon: 'pi pi-cloud-upload',
        },
        {
            label: "POS Journal File",
            path: "/ui/pos-journal",
            group: "Integration",
            module: "PosJournal",
            menuIcon: 'pi pi-wallet',
        },
        {
            label: "Store Items",
            path: "/ui/store-items",
            group: "store-items",
            module: "store-items",
            menuIcon: 'pi pi-database',
        },
        {
            label: "System ApiLogs",
            path: "/ui/sys-apilogs",
            group: "sys-apilogs",
            module: "sys-apilogs",
            menuIcon: 'pi pi-stop',
        },
        {
            label: "POS Command Events",
            path: "/ui/sys-events",
            group: "sys-events",
            module: "sys-events",
            menuIcon: 'pi pi-stop',
        }              
    ],
};

const SystemAdminMenu = {
    label: "System Admin",
    icon: SysAdminIcon,
    keywords: "consumer management,producer management",
    marginDimension: "0.5em",
    childMenu: "systemAdmin",
    highlightClass: "",
    module: "systemAdmin",
    configaccess: "showBroker",
    child: [
        {
            label: "File Management",
            path: "/ui/media-management",
            group: "systemAdmin",
            module: "systemAdmin",
            menuIcon: 'pi pi-file',
        },
        {
            label: "Users Management",
            path: "/ui/users-management",
            group: "systemAdmin",
            module: "systemAdmin",
            menuIcon: 'pi pi-user',
        },
        {
            label: "System Error Codes",
            path: "/ui/system-error-codes",
            group: "systemAdmin",
            module: "systemAdmin",
            menuIcon: 'pi pi-check-square',
        },
        {
            label: "System App Logger",
            path: "/ui/system-app-logger",
            group: "systemAdmin",
            module: "systemAdmin",
            menuIcon: 'pi pi-box',
        }
    ]
}

const DevOpsToolMenu = {
    label: "Devops Tool",
    icon: DevOppIcon,
    keywords: "pdevops management",
    marginDimension: "0.5em",
    childMenu: "devOpsTool",
    highlightClass: "",
    module: "systemAdmin",
    configaccess: "showBroker",
    child: [
        // {
        //     label: "Export File Logs",
        //     path: "/ui/devopstool/export/file-log",
        //     group: "systemAdmin",
        //     module: "DevOpsTool",
        //     menuIcon: 'pi pi-file',
        // },
        {
            label: "Export Table Logs",
            path: "/ui/devopstool/export/table-log",
            group: "systemAdmin",
            module: "DevOpsTool",
            menuIcon: 'pi pi-book',
        },
        {
            label: "Clean Up Table",
            path: "/ui/devopstool/cleanup-table",
            group: "systemAdmin",
            module: "DevOpsTool",
            menuIcon: 'pi pi-file',
        },
        {
            label: "Clean Up Disk",
            path: "/ui/devopstool/cleanup-disk",
            group: "systemAdmin",
            module: "DevOpsTool",
            menuIcon: 'pi pi-desktop',
        },
        {
            label: "Clean Up Logs",
            path: "/ui/devopstool/cleanup-log",
            group: "systemAdmin",
            module: "DevOpsTool",
            menuIcon: 'pi pi-cog',
        },
        {
            label: "Logs Parser",
            path: "/ui/devopstool/logs-parser",
            group: "systemAdmin",
            module: "DevOpsTool",
            menuIcon: 'pi pi-clock',
        },
    ]
}

const Sidebar = (props) => {

    const { userRole } = props;

    const [routesForSideBar, setRoutesForSideBar] = useState([]);

    useEffect(() => {
        if(userRole === "SystemAdmin"){
            setRoutesForSideBar([DashboardMenu, IntegrationMenu, SystemAdminMenu, DevOpsToolMenu])
        }else{
            setRoutesForSideBar([DashboardMenu, IntegrationMenu])
        }
    }, [userRole]);

    const [activeIndex, setActiveIndex] = useState("1");
    const refContainer = useRef({});

    const _setRef = (element) => {
        if (element) refContainer.current[element.id] = element;
    };

    const _collapseRef = (id, parent, index) => {
        const _refContainer = refContainer.current;
    
        if (!parent) {
            return;
        } else {
            for (const key of Object.keys(_refContainer)) {
                if (_refContainer[key].classList.contains("show")) {
                    if (
                        key !== id &&
                        !index.startsWith(activeIndex + "_") &&
                        activeIndex !== index
                    ) {
                        _refContainer[key].classList.toggle("show");
                        _refContainer[
                            key
                        ].previousSibling.lastElementChild.classList.remove(
                            "rotate_down"
                        );
                        _refContainer[
                            key
                        ].previousSibling.lastElementChild.classList.add(
                            "rotate"
                        );
                    }
                }
            }
    
            if (id) {
                _refContainer[id].classList.toggle("show");
    
                if (_refContainer[id].classList.contains("show")) {
                    _refContainer[
                        id
                    ].previousSibling.lastElementChild.classList.add(
                        "rotate_down"
                    );
                } else {
                    _refContainer[
                        id
                    ].previousSibling.lastElementChild.classList.remove(
                        "rotate_down"
                    );
                    _refContainer[
                        id
                    ].previousSibling.lastElementChild.classList.add("rotate");
                }
            }
        }
    };    

    const _matchIndex = (index) => {
        const splitTexts = index.split("_");
        return (
            splitTexts.findIndex(
                (splitText) =>
                    activeIndex === splitText ||
                    activeIndex.startsWith(splitText + "_")
            ) > -1
        );
    };

    
    const _drawMenuWithNoChild = (
        index,
        module,
        highlightClass,
        icon,
        isSideBarActive,
        path,
        label,
        marginDimension,
        menuIcon
    ) => {
        return (   
            <li
                key={index}
                style={{ display: "block" }}
                onClick={() => {
                    // Ensure sidebar remains open when clicking on a menu without children
                    _collapseRef("", true, index);
                    setActiveIndex(index);
                }}
                id={`tooltip_with_no_child_${index + 1}`}
                className={
                    isSideBarActive
                        ? _matchIndex(index)
                            ? `nav-selected tp`
                            : `${highlightClass}`
                        : "tp"
                }
                data-pr-tooltip={label}
            >
            <Link
                    to={path}
                    className={
                        isSideBarActive ? "" : _matchIndex(index) ? `nav-selected` : `${highlightClass}`
                    }
                >
                    {icon && <img alt={label} src={icon} />}
                    {menuIcon && <i className={menuIcon}></i>}
                    <span
                        className="menu-item"
                        style={{ marginLeft: marginDimension, paddingLeft: 0, justifyContent: !isSideBarActive ? 'center' : 'left' }}
                    >
                        {label}
                    </span>
                </Link>
                <span className="hover_span">{label}</span>
            </li>
        );
    };
    
    const _drawChild = (child, childMenu, index) => {
        const { label, path, icon, menuIcon } = child;
        return (
        
            <li
                key={index}
                style={{ display: "block" }}
                onClick={(event) => {
                    _collapseRef(childMenu, false, index);
                    event.stopPropagation();
                }}
                className="tp"
                id={`tooltip_${index}`}
                data-pr-tooltip={ label }
            >

                <Link to={path} style={{    paddingLeft: isSideBarActive ? '10px' : '0',  justifyContent:  !isSideBarActive ? 'center' : 'left' }}>
                { icon && <img alt={label} src={icon} />} 
                { menuIcon && <i className={menuIcon}></i> }
                    {isSideBarActive && <span
                        className="menu-item"
                        style={{paddingLeft: 0 }}
                    >
                        {label}
                    </span>}
                </Link>
            </li>
        );
    };

    const _drawMenuWithChild = (
        child,
        childMenu,
        index,
        module,
        highlightClass,
        icon,
        isSideBarActive,
        path,
        label,
        marginDimension,
        menuIcon
    ) => {
        return (
            <li
                key={index}
                style={{ display: "block" }}
                onClick={(event) => {
                    _collapseRef(childMenu, true, index);
                    setActiveIndex(index);
                    event.stopPropagation();
                }}
                id={`tooltip_with_child_${index}`}
                className={
                    !isSideBarActive
                        ? _matchIndex(index)
                            ? `nav-selected parent_li`
                            : `${highlightClass} parent_li`
                        : "parent_li"
                }
            >
                <a
                    href="/"
                    onClick={(event) => event.preventDefault()}
                    data-toggle="collapse"
                    aria-expanded="false"
                    className={
                        isSideBarActive
                            ? ""
                            : _matchIndex(index)
                            ? `nav-selected`
                            : `${highlightClass}`
                    }
                    style={{ display: 'flex', alignItems: 'center',  justifyContent:  !isSideBarActive ? 'center' : 'left'}}
                >
                    {icon && <img alt={label} src={icon} />}
                    {menuIcon && <i className={menuIcon}></i> }
                    <span
                        className="menu-item"
                        style={{ marginLeft: marginDimension, paddingLeft: 0,  justifyContent:  !isSideBarActive ? 'center' : 'left' }}
                    >
                        {label}
                    </span>
                    <img
                        alt=""
                        id="dropdown"
                        className="sidebar_dropdown rotate"
                        style={{ height: "0.8em", width: "0.8em" }}
                        src={SidebarArrow}
                    />
                </a>
                <ul
                    className={`collapse list-unstyled ${_matchIndex(index) ? "show" : ""}`} // Conditionally add 'show'
                    style={{ paddingLeft: `${index.split("_").length - 1}em`, justifyContent: !isSideBarActive ? 'center' : 'left' }}
                    id={childMenu}
                    data-parent="#sidebar"
                    ref={_setRef}
                >
                    {child.map((subChild, subIndex) => {
                        if (typeof subChild.child !== "undefined") {
                            return _drawMenu(
                                subChild,
                                `${index}_${subChild.childMenu}`
                            );
                        } else {
                            return _drawChild(
                                subChild,
                                childMenu,
                                `${index}_${subIndex.toString()}`
                            );
                        }
                    })}
                </ul>
                {/* <span className="hover_span">{label}</span> */}
            </li>
        );
    };

    const _drawMenu = (route, index) => {
        const {
            path,
            icon,
            label,
            child,
            childMenu,
            marginDimension,
            highlightClass,
            module,
            menuIcon
        } = route;

        const { isSideBarActive } = props;
        if (label === "ADMIN") {
            return (
                <li key={index} className="admindiv">
                    {label}
                </li>
            );
        } else if (typeof child === "undefined") {
            return _drawMenuWithNoChild(
                index,
                module,
                highlightClass,
                icon,
                isSideBarActive,
                path,
                label,
                marginDimension,
                menuIcon
            );
        } else {
            return _drawMenuWithChild(
                child,
                childMenu,
                index,
                module,
                highlightClass,
                icon,
                isSideBarActive,
                path,
                label,
                marginDimension,
                menuIcon
            );
        }
    };

    const { isSideBarActive } = props;
    
    return (
        <nav id="sidebar" className={!isSideBarActive ? "active " : ""}>
            {/* <div style={{ padding: "1.2em 0" }}>
                <span className="sidebaractive-header"></span>
                <div
                    className="menu"
                    style={{ display: "inline" }}
                    onClick={() => props.toggleSideBar()}
                ></div>
            </div> */}
            <ul className="list-unstyled components">
                {routesForSideBar.map((route, index) =>
                    _drawMenu(route, index.toString())
                )}
            </ul>
        </nav>
    );
};

export default Sidebar;
